<div class="dynamic-field form-input col-12" [formGroup]="group">
    <div class="row">
        <div class="col-3">
          <label>{{ config.name }}<span *ngIf="config.validation" style="color: red"> *</span> </label>
        </div>
        <div class="col-9" style="margin-bottom: 5px;">
          <p-calendar [locale]="calenderlocale" dateFormat="dd.mm.yy" [formControlName]="config.name" [monthNavigator]="true" [yearNavigator]="true" yearRange="1900:2030" [showIcon]="true" ></p-calendar>
        </div>
      </div>
  </div>